import { inject, Injectable, RendererFactory2 } from '@angular/core';
import { Subject } from 'rxjs';
import { JoyrideScroll } from '../joyride.domain';
import { WINDOW_TOKEN } from '../../../services/window.token';

@Injectable({ providedIn: 'root' })
export class JoyrideEventListenerService {
  scrollEvent: Subject<JoyrideScroll> = new Subject<JoyrideScroll>();
  resizeEvent: Subject<number> = new Subject<number>();

  private readonly renderer = inject(RendererFactory2).createRenderer(null, null);
  private scrollUnlisten: () => void;
  private resizeUnlisten: () => void;
  private readonly browserWindow = inject(WINDOW_TOKEN);

  startListeningScrollEvents(): void {
    this.scrollUnlisten = this.renderer.listen('document', 'scroll', () => {
      this.scrollEvent.next({
        scrollX: this.browserWindow.pageXOffset,
        scrollY: this.browserWindow.pageYOffset
      });
    });
  }

  startListeningResizeEvents(): void {
    this.resizeUnlisten = this.renderer.listen('window', 'resize', (size: number) => {
      this.resizeEvent.next(size);
    });
  }

  stopListeningScrollEvents(): void {
    this.scrollUnlisten();
  }

  stopListeningResizeEvents(): void {
    this.resizeUnlisten();
  }
}
